import React, { useEffect, useState } from "react";
import { Box, Button, Card, Grid2 as Grid, Stack, Typography } from "@mui/material";
import { BasicProfileCard } from "../BasicProfileCard";
import { NotificationList } from "./NotificationList";
import { SavedProfiles } from "./SavedProfiles";
import { acceptCollabRequest, getUserDetails, rejectCollabRequest } from "../../../config/apisauce";
import { usePage } from "@inertiajs/react";
import { GenericDialog } from "../../../components/generic/GenericDialog";
import { DECLINED } from "../../../enums/statusEnums";
import useStore from "../../../states/store";
import { GenericCircleIcon } from "../../../components/generic/GenericCircleIcon";
import { CheckCircle, XCircle } from "@phosphor-icons/react";
import { NeedHelp } from "../../../components/ui/topbar/generic/GenericDialogFooter";

const CreatorHomePage = () => {
  const { auth } = usePage().props;
  const [, { openLoader, closeLoader }] = useStore();
  const [creatorDetails, setCreatorDetails] = useState({});
  const [openCollabStatusDialog, setOpenCollabStatusDialog] = useState(false);
  const collabHash = sessionStorage.getItem('collabHash');
  const collabStatus = sessionStorage.getItem('collabStatus');

  const handleAcceptRejectCollabRequest = async () => {
    openLoader();
    const params = { hash: collabHash };
    const response = collabStatus === DECLINED ? await rejectCollabRequest(params) : await acceptCollabRequest(params);
    if (response.ok) {
      setOpenCollabStatusDialog(true);
    } else {
      handleClearSesssion();
    }
    closeLoader();
  };

  const handleClearSesssion = () => {
    sessionStorage.removeItem('collabHash');
    sessionStorage.removeItem('collabStatus');
  };

  const handleCloseCollabStatusDialog = () => {
    setOpenCollabStatusDialog(false);
    handleClearSesssion();
  };

  const fetchCreatorDetails = async () => {
    const { ok, data } = await getUserDetails({ user_id: auth?.user?.id });
    if (ok) {
      setCreatorDetails(data);
    }
  };

  useEffect(() => {
    fetchCreatorDetails();
  }, [])

  useEffect(() => {
    if (collabHash && collabStatus) handleAcceptRejectCollabRequest();
  }, [collabHash, collabStatus]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }} >
      <Typography variant="h5" fontWeight={700} color="primary.main" mb={1.5}>Overview</Typography>
      <BasicProfileCard userDetails={creatorDetails} refetchData={fetchCreatorDetails} />

      <Box sx={{ display: "flex", flexDirection: {xs: "column", sm: "row"}, gap: 2, height: 655, mt: 2 }} >
        <Card sx={{ width: { xs: "100%", sm: "50%" }, minHeight: "64vh", overflowY: "auto" }}>
          <NotificationList userId={auth?.user?.id} />
        </Card>
        <Box sx={{ width: { xs: "100%", sm: "50%" }, minHeight: "64vh" }}>
          <SavedProfiles />
        </Box>
      </Box>

      <GenericDialog
        textTransform={'capitalize'}
        title={`${collabStatus} Collab Request`}
        width={'550px'}
        openDialog={openCollabStatusDialog}
        handleClose={() => handleCloseCollabStatusDialog()}
      >
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} mb={2}>
          <GenericCircleIcon color={'primary.main'}>
            {collabStatus === DECLINED ? <XCircle size={96} weight="thin" /> : <CheckCircle size={96} weight="thin" />}
          </GenericCircleIcon>
        </Box>
        <Stack gap={3} alignItems={'center'}>
          <Typography variant="subtitle1" textAlign={'center'} fontWeight={700}>
            Collab request has been {collabStatus}!
          </Typography>
          <Button variant="contained" sx={{ width: { xs: '100%', sm: '250px' } }} onClick={() => handleCloseCollabStatusDialog()}>Got it!</Button>
          <NeedHelp />
        </Stack>
      </GenericDialog>
    </Box>
  );
};

export default CreatorHomePage;